<template>
  <div class="vipProductList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        @click="vipOperation('add', tableData)"
        class="add-input"
        >+新增商品权益配置</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      height="700"
      v-loading="loading"
      element-loading-text="拼命加载中"
      @sort-change="handleSortChange"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="privilegeName"
        label="特权"
        align="center"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.privilegeName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="img"
        label="图标"
        align="center"
      >
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.img"
            :width="'180px'"
            :height="'90px'"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="vipOperation('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="removeAdmin(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <productBenefit-action
      ref="addVip"
      @handlerProductList="handlerProductList"
    ></productBenefit-action>
  </div>
</template>
<script>
import API from "@/api";
import { sortEscape } from "@/utils/global";
import ProductBenefitAction from "./components/productBenefitAction"
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      tableData: [],
      // VIP商品列表请求参数
      param: {
        pageNumber: 1,
        pageSize: 100,
      },
    };
  },
  components: {
    ProductBenefitAction,
  },
  created() {
    this.getProductList(this.param);
  },
  methods: {
    // 请求商品列表
    getProductList() {
      this.loading = true;
      API.getProductBenefitList(this.param)
        .then((res) => {
          if (res.code === 200 && res.data.length > 0) {
            this.tableData = res.data;
          } else if (res.code === 200) {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.param.value = sortEscape(column.order);
      this.param.key = column.prop;
      this.getProductList(this.param);
    },
    // 删除管理员
    removeAdmin(row) {
      this.$confirm("您确定要删除吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.deleteProductBenefit({ id: row.id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getProductList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑操作
    vipOperation(type, data) {
      this.$refs.addVip.open(type, data);
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerProductList() {
      this.getProductList();
    },
  },
};
</script>

<style lang="scss">
.add-input {
  margin-left: 0 !important;
}
</style>
